import React from 'react'

/* plugin */
import { motion } from "framer-motion";
/* plugin end */


const AuthHeadingComp = () => {
    return (
        <div className="banner-box">
            <motion.h2
                initial={{ y: 60, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="banner-hdn"
            >
                Check your eligibility
            </motion.h2>
            <motion.div
                initial={{ y: 60, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="banner-para"
            >
                <p>
                    Takes a few minutes. For UK residents aged 21+
                </p>
            </motion.div>
        </div>
    )
}

export default AuthHeadingComp